<template>

<div>
    <div class="card info-flight">
        <div @click="toShowConnectingInfo=!toShowConnectingInfo" class="main-info-wrap">
            <div class="info-wrap">
                <div class="flight-name">
                    <div v-if="flightObj" class="logo">
                        <!-- <img
                                :src="$options.filters.ALimage(flightObj && flightObj[0].flight.opAirline)"
                                :onerror="defaultALImg"
                        /> -->
                        <img v-if='GET_AIRLINES'
                                :src="GET_AIRLINES[flightObj[0].flight.opAirline].logourl||defaultALImg"
                        />
                        
                    </div>

                    <div class="name">
                        <div class="t-flight-name">
                            {{flightObj && flightObj[0] &&
                            flightObj[0].flight.opAirline|airlineName}}
                        </div>
                        <span
                                class="flight-code"
                        >{{flightObj && flightObj[0] && flightObj[0].flight.FlightNo}}</span>
                        <span class="flight-code">
                      {{flightObj && flightObj[0] && flightObj[0].flight.DepDate|
                      formatDate(DATE_TIME_FORMAT.DAY_DATE_MONTH)}}
                    </span>
                    <span v-if="isDebug" class="provider">{{flightObj && flightObj[0] && flightObj[0].flight.providerID}}</span>
                    </div>
                </div>

                <div class="time-place-wrap">
                    <div class="left">
                        <div class="time" v-c-tooltip.hover="{
                      content:`${dateFormatInTooltip(flightObj[0].flight.DepDate)}
                       `,}">
                            {{flightObj && flightObj[0] &&
                            flightObj[0].flight.DepDate|formatDate(DATE_TIME_FORMAT.DEFAULT_TIME_FORMAT)}}
                        </div>
                        <div class="place-code">
                            {{flightObj &&
                            flightObj[0] &&
                            flightObj[0].flight.DepAirport}}
                        </div>
                        <div class="place">
                            {{flightObj && flightObj[0] &&
                            flightObj[0].flight.DepAirport | cityName}}
                        </div>
                    </div>
                    <div class="center">
                    <span>
                      {{flightObj && flightObj[0] && flightObj[0].flight.TotalDuration|
                      convertToHrMin("minutes","H [h] mm [m]")}}
                    </span>
                        <img src="@imgPath/img/svg/icons/flying-flight.svg" alt/>
<!--                      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="151.35" height="12.034" viewBox="0 0 151.35 12.034">-->
<!--                        <defs>-->
<!--                          <linearGradient id="linear-gradient" y1="0.5" x2="1" y2="1" gradientUnits="objectBoundingBox">-->
<!--                            <stop offset="0" stop-color="#2c374d" stop-opacity="0"/>-->
<!--                            <stop offset="1" stop-color="#b5b5b5"/>-->
<!--                          </linearGradient>-->
<!--                        </defs>-->
<!--                        <g id="Group_125" data-name="Group 125" transform="translate(-691 -848)">-->
<!--                          <rect id="Rectangle_18" data-name="Rectangle 18" width="137" height="2" rx="1" transform="translate(691 853)" fill="url(#linear-gradient)"/>-->
<!--                          <g id="_565360" data-name="565360" transform="translate(842.35 837.333) rotate(90)">-->
<!--                            <g id="Group_124" data-name="Group 124" transform="translate(10.667)">-->
<!--                              <path id="Path_14" data-name="Path 14" d="M22.7,8.867V7.6L17.634,4.433V.95a.95.95,0,1,0-1.9,0V4.433L10.667,7.6V8.867l5.067-1.583v3.483l-1.267.95v.95l2.217-.633,2.217.633v-.95l-1.267-.95V7.284Z" transform="translate(-10.667)"/>-->
<!--                            </g>-->
<!--                          </g>-->
<!--                        </g>-->
<!--                      </svg>-->


                      <span v-if="!isStopsForNonMyanmar"
                              class="stop"
                        >{{flightObj && flightObj[0].flight.no_of_stops && flightObj[0].flight.no_of_stops.name}}</span>
                        <!-- <span v-else -->
                        <!-- <span
                                class="via"
                        >{{flightObj && flightObj[0] && flightObj[0].flight.Via_Obj}}</span> -->
                        <span v-else-if="isStopsForNonMyanmar && flightObj.length==1"
                                class="via"
                        >{{flightObj && flightObj[0] && flightObj[0].flight.Via_Obj}}</span>
                        <span v-else-if="isStopsForNonMyanmar && flightObj.length>1"
                                class="via"
                        ><span>{{flightObj && flightObj[0] && flightObj[0].flight.no_of_stops && flightObj[0].flight.no_of_stops.name}}</span>
                <span >{{flightObj[0].flight.Via_Obj != 'Non-Stop'?', '+flightObj[0].flight.Via_Obj:null}}</span></span>
                    </div>

                    <div class="right">
                        <div class="time" v-c-tooltip.hover="{
                    content:`${dateFormatInTooltip(flightObj[flightObj.length-1].
                    flight.ArrDate)}

                                `,
                            }">
                            {{flightObj && flightObj[flightObj.length-1] &&
                            flightObj[flightObj.length-1].flight.ArrDate|formatDate(DATE_TIME_FORMAT.DEFAULT_TIME_FORMAT)}}
                            <span
                                    class="day" v-c-tooltip.hover="{
                              content:`${noOfDaysTooltip(flightObj[0].flight.no_of_days)}`,
                            }"
                            >{{ flightObj && flightObj[0] && flightObj[0].flight.no_of_days}}</span>
                        </div>
                        <div class="place-code">
                            {{flightObj && flightObj[flightObj.length-1] &&
                            flightObj[flightObj.length-1].flight.ArrAirport}}
                        </div>
                        <div class="place">
                            {{flightObj && flightObj[flightObj.length-1] &&
                            flightObj[flightObj.length-1].flight.ArrAirport | cityName}}
                        </div>
                    </div>
                </div>
                <div v-if="flightObj && flightObj[0] && flightObj[0].flight.baggage" class="luggage d-flex">
                    <img src="@imgPath/img/svg/icons/Suitcase_icon.svg" alt/>
                    <span>{{flightObj && flightObj[0] && flightObj[0].flight.baggage && flightObj[0].flight.baggage[0].weightinkg+' Kg'}}</span>
                </div>
            </div>
            <div>

            </div>
           
                
            
        </div>
        <div class="price-details-wrap">
            <div class="price-wrap">


                <div :class="(isShowMore || toShowMore(totalFlightObj)) ?'classnprice-wrap expand':'classnprice-wrap less'">
                    <table >

                        <tbody>
                        <tr v-for="(pUnit,pindex) in totalFlightObj"
                           :key="'pIdobagain'+pUnit.pId+pindex" :class="pUnit.selectStatus == noClass ? 'no-class'
                        :pUnit.selectStatus == selectedClass ? 'selected': pUnit.selectStatus == selectableClass ? 'selectable': 'disable'"
                           @click="pUnit.selectStatus == disableClass?click:$emit('updateflightls',pUnit)">
                            <td>
                                <div>
                                    <div @click="click" class="radio">
                                        <div role="group" class="custom-control custom-radio">
                                            <label v-if="pUnit.obFlight" for="c" class="custom-control-label">
                                                

                                                {{pUnit.obFlight[0].flight.Bookingclass}} {{pUnit.fareType ? '- '+
                                                pUnit.fareType : null}}
                                            </label>
                                            <label v-if="pUnit.ibFlight" for="c" class="custom-control-label">
                                                {{pUnit.ibFlight[0].flight.Bookingclass}} {{pUnit.fareType ? '- '+
                                                pUnit.fareType : null}}
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </td>

                            <td>
                                <div
                                        class="currency"
                                >{{pUnit.clientPricing && pUnit.clientPricing.Currency}}
                                </div>
                            </td>
                            <td>
                                <div class="value">
                                    {{pUnit.clientPricing && pUnit.clientPricing.AdultPrice.Total |
                                    amountformat}}
                                </div>
                            </td>
                           
                        </tr>

                        </tbody>

                    </table>

            

                </div>
                
                 <button @click="isShowMore==true?isShowMore=false:isShowMore=true" 
                        v-if="totalFlightObj.length>noOfMaxFare && isShowMore==false" class="expander">
                     <img  src="@imgPath/img/svg/icons/down-arrow.svg" alt/>
                    {{$t('flightResults.cMLFlightResCard.showMore')}}
                 </button>
               
            </div>
        </div>
       <cConnectingFlightInfo  v-if="toShowConnectingInfo" :selectedFlight="totalFlightObj"
            :isResultPage="true" :flightObject="flightObj"></cConnectingFlightInfo>
    </div>
    
 
</div>
</template>
<script>
    import BaseConfiguration from "../../config/base.js";
    import {
        COMPONENT_NAME,
        PATHNAME,DATE_TIME_FORMAT,
        FLIGHT_SELECTION_STATUS
    } from "../../util/constants";
import { mapGetters, mapActions } from "vuex";
import cConnectingFlightInfo from "./cConnectingFlightInfo"
    export default {
        name: COMPONENT_NAME.C_FLIGHTRESULTCARD,
        components:{
            cConnectingFlightInfo
        },
        props: {
            flightObj: {
                type: Object | Array
            },
            totalFlightObj: {
                type: Object | Array
            },
           
        },
        data: () => ({
            isDebug : BaseConfiguration.isDebug,
            defaultALImg: BaseConfiguration.defaultALImg,
            isStopsForNonMyanmar: BaseConfiguration.isStopsForNonMyanmar,
            noOfMaxFare: BaseConfiguration.maxFareList,
            noClass: FLIGHT_SELECTION_STATUS.noClass,
            selectedClass: FLIGHT_SELECTION_STATUS.selected,
            selectableClass: FLIGHT_SELECTION_STATUS.selectable,
            disableClass: FLIGHT_SELECTION_STATUS.disable,
            isShowMore:false,
            toShowConnectingInfo: false,

        }),
        computed: {
             DATE_TIME_FORMAT()
          {
            return DATE_TIME_FORMAT
          },
        ...mapGetters("sResult", {
      GET_AIRLINES: 'GET_AIRLINES',
     
    }),
        },
        created(){
            if(this.totalFlightObj.length!=0){
                this.toShowMore(this.totalFlightObj);
            }
            
        },
        methods: {
            click(e) {
                e.preventDefault();
            },

            

            toShowMore(ptotalFlightObj) {
                // let retValue;
                try {
                  if(BaseConfiguration.isDebug) console.log("toShowMore");
                  for (let index = 0; index < ptotalFlightObj.length; index++) {
                     if(ptotalFlightObj[index].selectStatus==1 && index>this.noOfMaxFare){
                         this.isShowMore=true;
                     }
                      
                  }
            
                } catch (err) {
                        let body = Logger.buildRequest(
                          FILE_NAME.C_FLIGHTRESULTCARD,
                          "error in toShowMore",
                          err.toString(),
                          "toShowMore",
                          LOG_TYPE.ERROR
                        );
                        Logger.getResponse(body);
                      }
                //   return retValue;
           }, 
            ///to get date object in particular format

            dateFormatInTooltip(pDate) {
                let retValue;
                try {
                    if (BaseConfiguration.isDebug) console.log("formatDate");
                    if (pDate != null) {
                        retValue = this.$options.filters.formatDate(
                            pDate,
                         
                            DATE_TIME_FORMAT.DAY_DATE_MONTH
                        );
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_FLIGHTRESULTCARD,
                        "error in dateFormatInTooltip",
                        err.toString(),
                        "dateFormatInTooltip",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return retValue;
            },


            ///to get no of days tooltip
            noOfDaysTooltip(pNoofDays) {
                let retValue;
                try {
                    if (BaseConfiguration.isDebug) console.log("noOfDaysTooltip");
                    if (pNoofDays) {
                        if (pNoofDays == 1) {
                            retValue = "Flight lands the next day";
                        } else {
                            pNoofDays = pNoofDays.replace("+", "");
                            retValue = "Flight lands after " + pNoofDays + " days";
                        }
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_FLIGHTRESULTCARD,
                        "error in noOfDaysTooltip",
                        err.toString(),
                        "noOfDaysTooltip",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return retValue;
            },

        }
    };
</script>
<style>
    .list-item {
        display: inline-block;
        margin-right: 10px;
    }

    .list-enter-active, .list-leave-active {
        transition: all 1s;
    }

    .list-enter, .list-leave-to /* .list-leave-active below version 2.1.8 */
    {
        opacity: 0;
        transform: translateY(30px);
    }
    span.provider {
    font-size: 10px;
    color: white;
}

</style>